<!--  -->
<template>
  <div class="tablwbox">
    <div class="srrwrw">
      <div>
        <el-input v-model="paquery.name" placeholder="请输入类型名称" style="width:200px;margin-right:10px" />
        <el-button type="primary" icon="el-icon-search" style="margin-left:10px" @click="srarch">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
      </div>
      <div>
        <el-button type="success" icon="el-icon-plus" @click="add(1)">新增类型</el-button>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="ID"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="类型名称"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="admin_name"
        label="创建人"
        width="300"
        align="center"
      >
        <template slot-scope="scope">
          {{ scope.row.admin_name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="edit(2,scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="新增/编辑类型"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="20%"
    >
      <seelooktypedialog ref="seelooktypedialogview" @updata="updata" />
    </el-dialog>
    <pagination-right
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { assortlist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import seelooktypedialog from './components/seelooktypedialog.vue'
export default {
  name: 'Wechatseting',
  components: {
    PaginationRight,
    seelooktypedialog
  },
  data() {
    return {
      dialogVisible: false,
      paquery: {
        page: 1,
        page_size: 10,
        name: ''
      },
      total: null,
      tableData: [],
      loading: false
    }
  },
  activated() {
    this.sawrlist()
  },
  created() {
    this.sawrlist()
  },
  mounted() {

  },
  methods: {
    async sawrlist() {
      this.loading = true
      const data = await assortlist(this.paquery)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data.data)
    },
    fetchPageSizeone(e) {
      this.paquery.page_size = e
      this.sawrlist()
    },
    fetchCurrentPageone(e) {
      this.paquery.page = e
      this.sawrlist()
    },
    srarch() {
      this.paquery.page = 1
      this.sawrlist()
    },
    reset() {
      this.paquery.page = 1
      this.paquery.page_size = 10
      this.paquery.name = ''
      this.sawrlist()
    },
    add(type) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.seelooktypedialogview.send(type)
      })
    },
    edit(type, item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.seelooktypedialogview.send(type, item)
      })
    },
    updata() {
      this.dialogVisible = false
      this.sawrlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tablwbox{
  padding: 20px;
}
.srrwrw{
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
